import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, Button, Card, Divider, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface CalendarHeaderProps {
  prevMonth: () => void;
  nextMonth: () => void;
  currentMonth: Date;
}

const CalendarHeader: FC<CalendarHeaderProps> = ({ prevMonth, nextMonth, currentMonth }) => {
  const { t, i18n } = useTranslation();

  const weekDaysWithTranslations: Record<string, string[]> = {
    ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    uz: ['Дш', 'Сш', 'Чр', 'Пш', 'Жм', 'Шн', 'Як'],
    oz: ['Dsh', 'Ssh', 'Chr', 'Psh', 'Jm', 'Shn', 'Yak'],
  };

  const weekDays = weekDaysWithTranslations[i18n.language];

  return (
    <Stack component={Card}>
      <Box display="flex" justifyContent="center" alignItems="center" p={2.5}>
        <Button variant="contained" sx={{ minWidth: 0, p: 0.5 }} onClick={prevMonth}>
          <ChevronLeft />
        </Button>

        <Typography variant="h4" width={200} textAlign="center">
          {t(`scheduleMonthYear.${currentMonth.getMonth()}`, {
            year: currentMonth.getFullYear(),
          })}
        </Typography>

        <Button variant="contained" sx={{ minWidth: 0, p: 0.5 }} onClick={nextMonth}>
          <ChevronRight />
        </Button>
      </Box>

      <Divider sx={{ mx: 2.5 }} />

      <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={1} py={2}>
        {weekDays.map((day, index) => (
          <Typography variant="h5" textAlign="center" color="grey.400" sx={{ flex: 1 }} key={index}>
            {day}
          </Typography>
        ))}
      </Box>
    </Stack>
  );
};

export default CalendarHeader;
